import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TransportManagementProfileItemFacade } from './transport-management-profile-item.facade';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementProfileItemGuard {
  constructor(private transportManagementProfileItemFacade: TransportManagementProfileItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { transportManagementProfileId },
    } = route;
    return checkStoreState(this.transportManagementProfileItemFacade, transportManagementProfileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportManagementProfileItemFacade);
  }
}
